// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sKvP","colMin":"styles_colMin__2tUs1"};